// Inspi Viewer Component
export const getInspiViewerSrc = (state) => { return state.source + state.version + '/inspi-viewer.js' }
export const getInspiViewerUser = (state) => { return state.user }
export const getInspiViewerToken = (state) => { return state.token }

// Product
export const isProductLoaded = (state) => { return state.productLoaded }
export const getProductName = (state) => { return state.productName }
export const getProductPrice = (state) => { return state.productPrice }

// UI
export const isMenuDisplayed = (state) => { return state.menuDisplayed }
export const isDividersDisplayed = (state) => { return state.dividersDisplayed }

// Header
export const isProductNameDisplayed = (state) => { return state.productNameDisplayed }
export const isProductPriceDisplayed = (state) => { return state.productPriceDisplayed }

// Gamepad
export const getGamepadButtonsColor = (state) => { return state.gamepadButtonsColor }
export const isArButtonDisplayed = (state) => { return state.arButtonDisplayed }
export const isResetButtonDisplayed = (state) => { return state.resetButtonDisplayed }
export const isDimensionsButtonDisplayed = (state) => { return state.dimensionsButtonDisplayed }
export const isScreenshotButtonDisplayed = (state) => { return state.screenshotButtonDisplayed }

// Screenshot
export const isFrontScreenshotEnabled = (state) => { return state.frontScreenshotEnabled }

// AR
export const isArLoading = (state) => { return state.arLoading }